import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled from "styled-components";
import { IconActivity, IconChat, IconDiscovery, IconWebsite, IconBin, IconCheckbox, IconCheckboxFill, IconCog, IconVisibility, IconVisibilityOff, IconCross, IconDocument, IconProfile, IconDownload, IconRadioFill, IconBell, IconHeart, IconAttachment, IconLinkedIn, IconExternalLink, IconChart, IconChevron, IconLogout, IconMail, IconPencil, IconPeople, IconRadio, IconMessage, IconPerson, IconPhoto, IconShare, IconPlus, IconNotification, IconPuzzle, IconSearch, IconWallet, IconUnion, IconDotsVertical, IconWarningOutline, IconErrorOutline, IconInfoOutline, IconSuccessOutline, IconSpinner, IconCopy, IconTick, IconVideocam, IconArchive, IconUserPlus, IconMinus, IconSmile, IconKey, IconEmoji, IconTree, IconTimelapse, IconStore, IconPersonDetails, IconSell, IconFilter, IconTarget, IconNotes, IconLock, IconLockOpen, IconStar, IconStarFill, IconLink, IconDrag, IconPin, IconSearchHistory, IconHistory, IconRefresh, IconCheckboxMinus, IconTroubleshoot, IconSchedule, IconKidStar, IconThumbUp, IconThumbDown, IconThumbUpFill, IconThumbDownFill, IconSend, IconTrendingUp, IconBookmark, IconBookmarkCheckFill, IconBug, IconSavings, IconFootprint, IconGroupWork, IconHourglassEmpty, IconSparkles, IconContentPasteSearch, IconEncrypted, IconTune, IconArrow, IconMerge, IconStackGroup, IconEventAvailable, IconDateRange, IconCalendarMonth, IconRepeat, IconBadge, IconSync, IconInterests, IconLogin, IconWebhook, IconExplore, IconMove, IconUndo, IconReleaseAlert, IconPremium, IconFlag } from "~/components/Icons";
import { genericColor } from "~/lib/resolvers";
const Wrapper = styled.i`
  ${_ref => {
  let {
    $s,
    theme
  } = _ref;
  return theme.spacing.resolve(theme, $s);
}};
  color: ${_ref2 => {
  let {
    theme,
    $color
  } = _ref2;
  return genericColor(theme, $color);
}};
  ${_ref3 => {
  let {
    $rotate
  } = _ref3;
  return $rotate && `transform: rotate(${$rotate}deg)`;
}};
  display: ${_ref4 => {
  let {
    $display
  } = _ref4;
  return $display;
}};
  min-width: ${_ref5 => {
  let {
    $size,
    theme
  } = _ref5;
  return $size * theme.typography.fontStep;
}}rem;
  max-width: ${_ref6 => {
  let {
    $size,
    theme
  } = _ref6;
  return $size * theme.typography.fontStep;
}}rem;
  min-height: ${_ref7 => {
  let {
    $size,
    theme
  } = _ref7;
  return $size * theme.typography.fontStep;
}}rem;
  max-height: ${_ref8 => {
  let {
    $size,
    theme
  } = _ref8;
  return $size * theme.typography.fontStep;
}}rem;
  vertical-align: middle;

  & > svg {
    display: block;
  }
`;
const IconResolver = _ref9 => {
  let {
    src
  } = _ref9;
  switch (src) {
    case "activity":
      return /*#__PURE__*/React.createElement(IconActivity, null);
    case "chart":
      return /*#__PURE__*/React.createElement(IconChart, null);
    case "chat":
      return /*#__PURE__*/React.createElement(IconChat, null);
    case "discovery":
      return /*#__PURE__*/React.createElement(IconDiscovery, null);
    case "document":
      return /*#__PURE__*/React.createElement(IconDocument, null);
    case "notification":
      return /*#__PURE__*/React.createElement(IconNotification, null);
    case "people":
      return /*#__PURE__*/React.createElement(IconPeople, null);
    case "person":
      return /*#__PURE__*/React.createElement(IconPerson, null);
    case "search":
      return /*#__PURE__*/React.createElement(IconSearch, null);
    case "union":
      return /*#__PURE__*/React.createElement(IconUnion, null);
    case "wallet":
      return /*#__PURE__*/React.createElement(IconWallet, null);
    case "photo":
      return /*#__PURE__*/React.createElement(IconPhoto, null);
    case "checkbox":
      return /*#__PURE__*/React.createElement(IconCheckbox, null);
    case "checkboxFill":
      return /*#__PURE__*/React.createElement(IconCheckboxFill, null);
    case "radio":
      return /*#__PURE__*/React.createElement(IconRadio, null);
    case "radioFill":
      return /*#__PURE__*/React.createElement(IconRadioFill, null);
    case "cross":
      return /*#__PURE__*/React.createElement(IconCross, null);
    case "chevron":
      return /*#__PURE__*/React.createElement(IconChevron, null);
    case "attachment":
      return /*#__PURE__*/React.createElement(IconAttachment, null);
    case "download":
      return /*#__PURE__*/React.createElement(IconDownload, null);
    case "message":
      return /*#__PURE__*/React.createElement(IconMessage, null);
    case "mail":
      return /*#__PURE__*/React.createElement(IconMail, null);
    case "external-link":
      return /*#__PURE__*/React.createElement(IconExternalLink, null);
    case "bell":
      return /*#__PURE__*/React.createElement(IconBell, null);
    case "puzzle":
      return /*#__PURE__*/React.createElement(IconPuzzle, null);
    case "heart":
      return /*#__PURE__*/React.createElement(IconHeart, null);
    case "dots-vertical":
      return /*#__PURE__*/React.createElement(IconDotsVertical, null);
    case "plus":
      return /*#__PURE__*/React.createElement(IconPlus, null);
    case "website":
      return /*#__PURE__*/React.createElement(IconWebsite, null);
    case "linked-in":
      return /*#__PURE__*/React.createElement(IconLinkedIn, null);
    case "profile":
      return /*#__PURE__*/React.createElement(IconProfile, null);
    case "cog":
      return /*#__PURE__*/React.createElement(IconCog, null);
    case "log-out":
      return /*#__PURE__*/React.createElement(IconLogout, null);
    case "bin":
      return /*#__PURE__*/React.createElement(IconBin, null);
    case "pencil":
      return /*#__PURE__*/React.createElement(IconPencil, null);
    case "share":
      return /*#__PURE__*/React.createElement(IconShare, null);
    case "visibility":
      return /*#__PURE__*/React.createElement(IconVisibility, null);
    case "visibilityOff":
      return /*#__PURE__*/React.createElement(IconVisibilityOff, null);
    case "warningOutline":
      return /*#__PURE__*/React.createElement(IconWarningOutline, null);
    case "successOutline":
      return /*#__PURE__*/React.createElement(IconSuccessOutline, null);
    case "infoOutline":
      return /*#__PURE__*/React.createElement(IconInfoOutline, null);
    case "errorOutline":
      return /*#__PURE__*/React.createElement(IconErrorOutline, null);
    case "spinner":
      return /*#__PURE__*/React.createElement(IconSpinner, null);
    case "user-plus":
      return /*#__PURE__*/React.createElement(IconUserPlus, null);
    case "copy":
      return /*#__PURE__*/React.createElement(IconCopy, null);
    case "tick":
      return /*#__PURE__*/React.createElement(IconTick, null);
    case "videocam":
      return /*#__PURE__*/React.createElement(IconVideocam, null);
    case "archive":
      return /*#__PURE__*/React.createElement(IconArchive, null);
    case "minus":
      return /*#__PURE__*/React.createElement(IconMinus, null);
    case "smile":
      return /*#__PURE__*/React.createElement(IconSmile, null);
    case "key":
      return /*#__PURE__*/React.createElement(IconKey, null);
    case "emoji":
      return /*#__PURE__*/React.createElement(IconEmoji, null);
    case "tree":
      return /*#__PURE__*/React.createElement(IconTree, null);
    case "timelapse":
      return /*#__PURE__*/React.createElement(IconTimelapse, null);
    case "store":
      return /*#__PURE__*/React.createElement(IconStore, null);
    case "personDetails":
      return /*#__PURE__*/React.createElement(IconPersonDetails, null);
    case "sell":
      return /*#__PURE__*/React.createElement(IconSell, null);
    case "filter":
      return /*#__PURE__*/React.createElement(IconFilter, null);
    case "target":
      return /*#__PURE__*/React.createElement(IconTarget, null);
    case "notes":
      return /*#__PURE__*/React.createElement(IconNotes, null);
    case "lock":
      return /*#__PURE__*/React.createElement(IconLock, null);
    case "lockOpen":
      return /*#__PURE__*/React.createElement(IconLockOpen, null);
    case "star":
      return /*#__PURE__*/React.createElement(IconStar, null);
    case "starFill":
      return /*#__PURE__*/React.createElement(IconStarFill, null);
    case "link":
      return /*#__PURE__*/React.createElement(IconLink, null);
    case "drag":
      return /*#__PURE__*/React.createElement(IconDrag, null);
    case "pin":
      return /*#__PURE__*/React.createElement(IconPin, null);
    case "searchHistory":
      return /*#__PURE__*/React.createElement(IconSearchHistory, null);
    case "history":
      return /*#__PURE__*/React.createElement(IconHistory, null);
    case "refresh":
      return /*#__PURE__*/React.createElement(IconRefresh, null);
    case "checkboxMinus":
      return /*#__PURE__*/React.createElement(IconCheckboxMinus, null);
    case "troubleshoot":
      return /*#__PURE__*/React.createElement(IconTroubleshoot, null);
    case "schedule":
      return /*#__PURE__*/React.createElement(IconSchedule, null);
    case "kidStar":
      return /*#__PURE__*/React.createElement(IconKidStar, null);
    case "thumbUp":
      return /*#__PURE__*/React.createElement(IconThumbUp, null);
    case "thumbUpFill":
      return /*#__PURE__*/React.createElement(IconThumbUpFill, null);
    case "thumbDown":
      return /*#__PURE__*/React.createElement(IconThumbDown, null);
    case "thumbDownFill":
      return /*#__PURE__*/React.createElement(IconThumbDownFill, null);
    case "send":
      return /*#__PURE__*/React.createElement(IconSend, null);
    case "trendingUp":
      return /*#__PURE__*/React.createElement(IconTrendingUp, null);
    case "bookmark":
      return /*#__PURE__*/React.createElement(IconBookmark, null);
    case "bookmarkCheckFill":
      return /*#__PURE__*/React.createElement(IconBookmarkCheckFill, null);
    case "bug":
      return /*#__PURE__*/React.createElement(IconBug, null);
    case "savings":
      return /*#__PURE__*/React.createElement(IconSavings, null);
    case "footprint":
      return /*#__PURE__*/React.createElement(IconFootprint, null);
    case "groupWork":
      return /*#__PURE__*/React.createElement(IconGroupWork, null);
    case "hourglassEmpty":
      return /*#__PURE__*/React.createElement(IconHourglassEmpty, null);
    case "sparkles":
      return /*#__PURE__*/React.createElement(IconSparkles, null);
    case "contentPasteSearch":
      return /*#__PURE__*/React.createElement(IconContentPasteSearch, null);
    case "encrypted":
      return /*#__PURE__*/React.createElement(IconEncrypted, null);
    case "tune":
      return /*#__PURE__*/React.createElement(IconTune, null);
    case "arrow":
      return /*#__PURE__*/React.createElement(IconArrow, null);
    case "merge":
      return /*#__PURE__*/React.createElement(IconMerge, null);
    case "stackGroup":
      return /*#__PURE__*/React.createElement(IconStackGroup, null);
    case "dateRange":
      return /*#__PURE__*/React.createElement(IconDateRange, null);
    case "eventAvailable":
      return /*#__PURE__*/React.createElement(IconEventAvailable, null);
    case "calendarMonth":
      return /*#__PURE__*/React.createElement(IconCalendarMonth, null);
    case "repeat":
      return /*#__PURE__*/React.createElement(IconRepeat, null);
    case "badge":
      return /*#__PURE__*/React.createElement(IconBadge, null);
    case "sync":
      return /*#__PURE__*/React.createElement(IconSync, null);
    case "interests":
      return /*#__PURE__*/React.createElement(IconInterests, null);
    case "login":
      return /*#__PURE__*/React.createElement(IconLogin, null);
    case "webhook":
      return /*#__PURE__*/React.createElement(IconWebhook, null);
    case "explore":
      return /*#__PURE__*/React.createElement(IconExplore, null);
    case "move":
      return /*#__PURE__*/React.createElement(IconMove, null);
    case "undo":
      return /*#__PURE__*/React.createElement(IconUndo, null);
    case "releaseAlert":
      return /*#__PURE__*/React.createElement(IconReleaseAlert, null);
    case "premium":
      return /*#__PURE__*/React.createElement(IconPremium, null);
    case "flag":
      return /*#__PURE__*/React.createElement(IconFlag, null);
    default:
      return /*#__PURE__*/React.createElement("i", null);
  }
};
const Icon = _ref10 => {
  let {
    src,
    scale = 4,
    color = "inherit",
    rotate = 0,
    display = "inline-block",
    tip,
    s,
    ...rest
  } = _ref10;
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $s: s,
    $size: scale,
    $rotate: rotate,
    $display: display,
    $color: color,
    "data-tip": tip
  }, rest), /*#__PURE__*/React.createElement(IconResolver, {
    src: src
  }));
};
export default Icon;